import { MR, MRS, ND } from '@/model/salutations'
import { ROLE_TREND_MANAGER, ROLE_USER } from '@/model/roles'

export default {
    action: {
        password: 'Password e-mail',
        save: 'Save',
        save_and_close: 'Save Close',
        close: 'Close'
    },
    element: {
        sendPasswordMail: 'Send password e-mail immediately',
        email: {
            label: 'E-Mail',
            error: {
                required: 'Please enter an e-mail address!',
                email: 'Please enter a valid e-mail address!'
            }
        },
        salutation: {
            label: 'Salutation',
            error: 'Please choose a salutation!',
            [MRS]: 'Ms',
            [MR]: 'Mr',
            [ND]: 'n/d'
        },
        firstName: {
            label: 'First name',
            error: 'Please enter a first name!'
        },
        lastName: {
            label: 'Last name',
            error: 'Please enter a surname!'
        },
        phone: {
            label: 'Phone'
        },
        company: {
            label: 'Company'
        },
        position: {
            label: 'Job position'
        },
        role: {
            label: 'Role',
            error: {
                required: 'Please choose a roll!',
                [ROLE_USER]: 'The available number of active users has been reached.',
                [ROLE_TREND_MANAGER]: 'The available number of active managers has been reached.'
            }
        },
        locale: {
            label: 'Language',
            de: 'german',
            en: 'english'
        },
        password: {
            label: 'Password',
            hint: 'optional'
        },
        state: {
            active: 'State: active',
            inactive: 'State: inactive'
        }
    }
}
